import React, { useState } from 'react';
import { IconButton, Snackbar } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import theme from '../../theme';
import { useUserStore } from '../../stores/userStore';
import { trackShareClick } from '../../lib/gaEvents';
import { shareOrCopyUrl } from '../../utils/share';

const ShareButton = ({ url, contentType, contentId, contentName, shareTitle, shareText, pageType }) => {
  const user = useUserStore((state) => state.user);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleShare = async () => {
    try {
      const result = await shareOrCopyUrl({
        url,
        title: shareTitle || contentName,
        text: shareText || (contentName ? `${contentName} - postpop` : 'Postpop. Your Own Archive'),
      });
      if (result === 'copied') {
        setSnackbarOpen(true);
      }
      if (result !== 'cancelled' && contentType && contentId != null) {
        trackShareClick({ contentType, contentId, contentName, pageType }, user);
      }
    } catch (err) {
      console.error('Failed to share link:', err);
    }
  };

  return (
    <>
      <IconButton
        disableRipple
        onClick={handleShare}
        aria-label="share"
        sx={{
          width: { xs: 32, md: 40 },
          height: { xs: 32, md: 40 },
          p: 1,
          border: `1px solid ${theme.palette.grey.line}`,
          borderRadius: 1,
        }}
      >
        <ShareIcon
          sx={{
            width: { xs: 16, md: 24 },
            height: { xs: 16, md: 24 },
          }}
        />
      </IconButton>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="공유 문구와 링크가 복사되었습니다."
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  );
};

export default ShareButton;
